/**
 * Collapse consecutive blank lines inside a custom Streamdown block tag.
 *
 * CommonMark closes HTML blocks on a blank line, so a model-emitted gap between
 * a bullet list and trailing caveat lines would split `<keySafetyNotes>` (or
 * `<keypoints>` / `<safetycallout>`) and drop the tail back into plain prose.
 */
export function collapseCustomBlockBlankLines(markdown: string, tagName: string): string {
  const pattern = new RegExp(`<${tagName}>([\\s\\S]*?)<\\/${tagName}>`, 'g');
  return markdown.replace(
    pattern,
    (_match, content: string) =>
      `<${tagName}>${content.replace(/\n\n+/g, '\n')}</${tagName}>`
  );
}
